import { useTranslation } from 'react-i18next';
import { FadeUp, Stagger, StaggerItem } from '../components/Motion';
import { Sprout, Heart, GraduationCap, Award } from 'lucide-react';

export default function About() {
  const { t } = useTranslation();
  const values = t('about.values', { returnObjects: true });
  const valueIcons = [Sprout, Heart, GraduationCap, Award];

  return (
    <main data-testid="about-page" className="pt-32">
      <section className="container-x max-w-7xl mx-auto pb-12">
        <FadeUp>
          <p className="overline">{t('about.overline')}</p>
          <h1 className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl text-ink tracking-tight max-w-4xl text-balance">
            {t('about.title')}
          </h1>
        </FadeUp>
      </section>

      <section className="container-x max-w-7xl mx-auto pb-20 grid gap-12 lg:grid-cols-12 items-start">
        <FadeUp delay={0.1} className="lg:col-span-7">
          <p className="text-lg text-ink-soft leading-relaxed">{t('about.intro')}</p>
        </FadeUp>
        <FadeUp delay={0.2} className="lg:col-span-4 lg:col-start-9">
          <div className="aspect-[4/5] rounded-3xl overflow-hidden">
            <img src="https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/5xkjar73_IMG_7043.jpeg" alt="Madame Marthe TOE/PARE — Fondatrice" className="w-full h-full object-cover" />
          </div>
        </FadeUp>
      </section>

      <section className="bg-forest text-bone py-24">
        <div className="container-x max-w-7xl mx-auto grid gap-12 lg:grid-cols-2">
          <FadeUp>
            <p className="overline text-sun">{t('about.founder_title')}</p>
            <h2 className="mt-3 font-heading text-4xl sm:text-5xl tracking-tight">{t('about.founder_name')}</h2>
            <p className="mt-2 text-sun font-medium">{t('about.founder_role')}</p>
          </FadeUp>
          <FadeUp delay={0.15}>
            <p className="text-lg text-bone/85 leading-relaxed">{t('about.founder_bio')}</p>
          </FadeUp>
        </div>
      </section>

      <section className="container-x max-w-7xl mx-auto py-24 grid gap-16 lg:grid-cols-2">
        <FadeUp>
          <div className="border-l-4 border-sun pl-6">
            <p className="overline">{t('about.mission_title')}</p>
            <p className="mt-4 font-heading text-2xl text-ink leading-snug">{t('about.mission_text')}</p>
          </div>
        </FadeUp>
        <FadeUp delay={0.15}>
          <div className="border-l-4 border-earth pl-6">
            <p className="overline">{t('about.vision_title')}</p>
            <p className="mt-4 font-heading text-2xl text-ink leading-snug">{t('about.vision_text')}</p>
          </div>
        </FadeUp>
      </section>

      <section className="bg-sand/50 py-24">
        <div className="container-x max-w-7xl mx-auto">
          <FadeUp>
            <h2 className="font-heading text-4xl sm:text-5xl tracking-tight">{t('about.values_title')}</h2>
          </FadeUp>
          <Stagger className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {values.map((v, i) => {
              const Icon = valueIcons[i];
              return (
                <StaggerItem key={v.t}>
                  <div className="bg-white rounded-3xl border border-border-soft p-8 hover-lift h-full">
                    <div className="w-12 h-12 grid place-items-center rounded-2xl bg-forest/8 text-forest mb-5">
                      <Icon size={22} strokeWidth={1.6} />
                    </div>
                    <h3 className="font-heading text-2xl text-ink mb-3">{v.t}</h3>
                    <p className="text-ink-soft leading-relaxed">{v.d}</p>
                  </div>
                </StaggerItem>
              );
            })}
          </Stagger>
        </div>
      </section>
    </main>
  );
}
